module.exports = __webpack_public_path__ + "img/backarrow.fa3d33ef.png";